// Entry file for JS
// polyfills
import '@babel/polyfill';
import './vendor/polyfills/forEach';

// Analytics
import { Analytics } from './helpers/analytics';

// Custom components
import { Accordion } from './components/accordion';
import { AddToCalendar } from './components/add-to-calendar';
import { Autosuggest } from './components/autosuggest';
import { BackButton } from './components/backbutton';
import { ComboBox } from './components/combo-box';
import { Draggable } from './components/draggable';
import { ExpandFaq } from './components/expand-faq';
import { ExpandRichText } from './components/expand-rich-text';
import { FormHandler } from './components/form';
import { HighlightListHeight } from './components/highlight-list-height';
import { ImageGallery } from './components/image-gallery';
import { Notification } from './components/notification';
import { LazyloadBoards } from './components/lazyload-boards';
import { PersonSlider } from './components/person-slider';
import { Podcast } from './components/podcast';
import { SalesForceApplicationForm } from './applications/sf-apply-form';
import { SearchJobcount } from './components/search-jobcount';
import { Sticky } from './components/sticky';
import { Tabsmenu } from './components/tabsmenu';
import { Textarea } from './components/textarea';
import { Video } from './components/video';
import { Goodhabitz } from './components/goodhabitz';

import { ScrollToAnchor } from './components/scroll-to-anchor';
import {showAfterScroll} from './components/show-after-scroll';
import {JobSave} from './components/job-save';
import {ScrollDetector} from './components/scroll-detector';
import {Jobboard} from './applications/jobboard';
import {Toggler} from './components/toggler';
import {SetSticky} from './components/set-sticky';
import {ScrollToParam} from './components/scrollToParameter';

const components = [
	Accordion,
	AddToCalendar,
	Autosuggest,
	BackButton,
	ComboBox,
	Draggable,
	ExpandFaq,
	ExpandRichText,
	FormHandler,
	HighlightListHeight,
	ImageGallery,
	Jobboard,
	JobSave,
	LazyloadBoards,
	PersonSlider,
	Podcast,
	Notification,
	SalesForceApplicationForm,
	ScrollDetector,
	SearchJobcount,
	showAfterScroll,
	SetSticky,
	Sticky,
	Tabsmenu,
	Textarea,
	Toggler,
	Video,
	Goodhabitz //@TODO: Use Goodhabitz as dynamic import because it's used with BMC aswell
];

const createComponents = () => {
    for (let i = 0; i < components.length; i = i + 1) {
        const componentsList = document.querySelectorAll(components[i].getSelector());

        if (componentsList.length) {
            for (const component of componentsList) {
                const componentDataString = component.getAttribute('data-component');
				const componentDataJson = componentDataString ? JSON.parse(componentDataString) : null;
				const componentData = componentDataJson ? componentDataJson[components[i].name] : undefined;
				new components[i](component, componentData);
            }
        }
    }
};

if(!window.Analytics) window.Analytics = new Analytics();
window.ScrollToAnchor = new ScrollToAnchor();

createComponents();

new ScrollToParam('current');
